import { useEffect, useState } from 'react';
import { createWhitelist, updateWhitelist, getWhitelist, deleteWhitelist } from "../../api/system";
import { Table, message, Typography, Flex, Button, Popconfirm } from 'antd';

const WhitelistView = () => {
    const tabCols = [
        {
            title: 'Index',
            dataIndex: 'id',
            key: 'id',
            render: (text, _, index) => (index + 1),
        },
        {
            title: 'User Email',
            dataIndex: 'email',
            key: 'email',
            render: (text, record) => {
                let val = record.email;
                return <Typography.Text editable={
                    {
                        onChange: (value) => {
                            val = value;
                        },
                        onEnd: () => {
                            editHandle({ ...record, email: val });
                        }
                    }
                }>{text}</Typography.Text>
            },
            width: '50%',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    <Button.Group size='small'>
                        <Popconfirm
                            title="Delete Action"
                            description="Are you sure to delete this email in whitelist?"
                            onConfirm={() => { deleteHandle(record) }}
                            okText="Yes"
                            cancelText="No" >
                            <Button danger type='link'>Delete</Button>
                        </Popconfirm>
                    </Button.Group>
                )
            }
        }
    ];

    const [tabData, setTabData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        setLoading(true);
        getWhitelist({'page.disable': true}).then(res => {
            if (res.list) {
                setTabData(res.list);
            }
        }).finally(() => setLoading(false))
    }

    const deleteHandle = (item) => {
        if(parseInt(item.id) <= 0) {
            setTabData([...tabData].filter(old => old !== item));
            return;
        }
        setLoading(true);
        deleteWhitelist(item.id).then(res => {
            if(res) {
                message.success('deleted!');
                setLoading(false);
                fetchData();
            }
        }).catch((err) => {
            message.error(String(err));
            setLoading(false);
        })
    }

    const editHandle = (params) => {
        setLoading(true);
        if(parseInt(params.id) > 0) {
            updateWhitelist(params).then(res => {
                if(res) {
                    message.success('updated!');
                    fetchData();
                }
            }).catch(err => {
                message.error(String(err));
            }).finally(() => setLoading(false));
        } else {
            let newParams = {...params};
            delete newParams['id'];
            createWhitelist(newParams).then(res => {
                if(res) {
                    message.success('created!');
                    fetchData();
                }
            }).catch(err => {
                message.error(String(err));
            }).finally(() => setLoading(false));
        }
        
    }

    const addNewWhitelist = () => {
        if(tabData.findIndex(item => item.id === '-1') >= 0) return;
        setTabData([
            {
                id: '-1',
                email: '',
            }, ...tabData
        ]);
    }

    return (
        <div>
            <Flex justify='flex-end' style={{paddingBottom: 20, marginRight: 20}}>
                <Button type='primary' onClick={addNewWhitelist}>Add New Whitelist</Button>
            </Flex>
            <Table
                scroll={{ x: true }}
                loading={loading}
                rowKey={(record) => record.id}
                rowClassName={'table-row'}
                size='small'
                dataSource={tabData}
                columns={tabCols}
                pagination={{showTotal: (total) => `Total ${total}`}} />
        </div>
    )
}

export default WhitelistView;